export default __webpack_public_path__ + "static/media/maduro5.55afbf20.png";